'use client';

import type React from 'react';

// @google/genai FIX: Updated component to accept and spread all SVG props (like x, y, width, height) to the underlying SVG element.
const ScorpioIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Scorpio</title>
    <path
      d="M5.39044 3.68766C5.21793 3.47202 4.90329 3.43706 4.6876 3.60957C4.47202 3.78207 4.43706 4.09672 4.60957 4.31235L6.5 6.67539V17H7.5V6.68188L9.12219 4.74719C9.32241 4.50839 9.6893 4.50895 9.88944 4.74835L11.5 6.68103V17H12.5V6.68103L14.1159 4.74196C14.3158 4.50208 14.6842 4.50208 14.8841 4.74196L16.3841 6.54196C16.459 6.63182 16.5 6.74508 16.5 6.86205V14.4983L16.5 14.5V16.8486C16.5 17.3721 16.6549 17.8838 16.9453 18.3193C17.437 19.057 18.2649 19.5 19.1514 19.5H20V20.7586C20 20.8477 20.1077 20.8923 20.1707 20.8293L21.9293 19.07C21.9683 19.0317 21.9683 18.9683 21.9293 18.9293L20.1707 17.1707C20.1077 17.1077 20 17.1523 20 17.2414V18.5H19.1514C18.5992 18.5 18.0836 18.2241 17.7774 17.7646C17.5965 17.4934 17.5 17.1746 17.5 16.8486L17.5 6.86205C17.5 6.51115 17.377 6.17135 17.1523 5.90178L15.6523 4.10178C15.0526 3.38215 13.9474 3.38214 13.347 4.10178L12 5.71898L10.6577 4.10817C10.0591 3.38995 8.95659 3.38828 8.35591 4.10469L7.009 5.71097L5.39044 3.68766Z"
      fill="currentColor"
    />
  </svg>
);

export default ScorpioIcon;
